import '../../styles-new/pages/author.scss';
import generateTabs from '../components/generateTabs'
// import '../components/copy-to-clipboard';

// generateTabs('sidebar', { hasCaching: false });
generateTabs('sidebar-last', { isLoadMore: false });

// const readMoreEl = document.querySelector('.author-sidebar__read-more');
// const aboutContentEl = document.querySelector('.author-sidebar__description');
// const aboutContentText = aboutContentEl.textContent;

// if (aboutContentText.length > 181) {
//     aboutContentEl.innerHTML = aboutContentText.slice(0, 181) + '...';
// } else {
//     readMoreEl.hidden = true;
// }

// aboutContentEl.innerHTML = '';
